import React, { Component } from 'react';
import '../styles/monthly-registration/monthlyRegistration.css';
import ProgressSteps from './components/ProgressSteps';
import ArenaHeader from './components/ArenaHeader';
import PlanGrid from './components/PlanGrid';
import CustomerInfo from './components/CustomerInfo';
import { getInitialState, initializePlanState } from './helpers/stateHelpers';
import { getArenaDetails, getMonthlyPlans, calculateAccountPrice, submitRequest } from './helpers/apiHelpers';
import { buildIndividualRequest, buildAccountRequest, addTimestampsToAlternateVehicles } from './helpers/requestBuilders';

export default class MonthlyRegistrationContainer extends Component {
  constructor(props) {
    super(props);
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.env = process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT.toLowerCase() : '';
    this.urlParams = new URLSearchParams(window.location.search);
    this.state = getInitialState(this.urlParams);
  }

  componentDidMount() {
    const root = document.getElementById('root');
    if (root) {
      root.classList.add('monthly-registration-font');
    }
    this.initData();
  }

  componentWillUnmount() {
    const root = document.getElementById('root');
    if (root) {
      root.classList.remove('monthly-registration-font');
    }
  }

  initData() {
    const idParam = this.urlParams.get('id');
    if (!idParam || !this.baseUrl) {
      this.setState({
        loading: false,
        error: 'Missing arena information'
      });
      return;
    }
    this.getArenaDetails(idParam);
  }

  getArenaDetails = (arenaHash) => {
    getArenaDetails(
      arenaHash,
      this.baseUrl,
      this.urlParams,
      (updates, callback) => {
        this.setState(updates, callback);
      },
      this.getMonthlyPlans
    );
  };

  getMonthlyPlans = (parkingId) => {
    getMonthlyPlans(
      parkingId,
      this.baseUrl,
      this.state,
      (updates) => this.setState(updates)
    );
  };

  handlePlanSelect = (plan) => {
    const planState = initializePlanState(plan, this.state.parkingId);
    this.setState(planState);
  };

  calculateAccountPrice = () => {
    calculateAccountPrice(
      this.state,
      this.baseUrl,
      this.urlParams,
      (updates) => this.setState(updates)
    );
  };

  handleContinue = () => {
    if (!this.state.selectedPlan) {
      return;
    }
    this.calculateAccountPrice();
  };

  handleBackToPlans = () => {
    this.setState({ currentStep: 1 });
  };

  handleContinueToPayment = () => {
    const subscriptionType = this.state.subscriptionType || this.state.selectedPlan?.subscriptionType || 'individual';
    const request = subscriptionType === 'account' ? buildAccountRequest(this.state) : buildIndividualRequest(this.state);
    
    let submitRequestData = { ...request };
    
    if (submitRequestData.type === 'individual') {
      submitRequestData.vehicle_detail = addTimestampsToAlternateVehicles(submitRequestData.vehicle_detail, 'individual', this.state.timeZone);
    } else if (submitRequestData.type === 'account') {
      submitRequestData.users_info = addTimestampsToAlternateVehicles(submitRequestData.users_info, 'account', this.state.timeZone);
    }
    
    submitRequest(
      submitRequestData,
      this.baseUrl,
      this.env,
      this.state,
      (updates) => this.setState(updates),
      this.manageBodyBackground
    );
  };

  handleIndividualChange = (e) => {
    const fields = { ...this.state.individualFields };
    fields[e.target.name] = e.target.value;
    this.setState({ individualFields: fields });
  };

  handleIndividualAreaCode = (areaCode) => {
    const fields = { ...this.state.individualFields };
    fields['areaCode'] = areaCode;
    this.setState({ individualFields: fields });
  };

  handleIndividualDateChange = (value) => {
    this.setState({ individualValidity: value });
  };

  addAlternateVehicle = () => {
    const limit = this.state.alternateVehicleLimit || 0;
    if (limit > 0 && this.state.alternateVehicles.length >= limit) {
      return;
    }
    this.setState({
      alternateVehicles: [
        ...this.state.alternateVehicles,
        { vehicle_no: '', vehicle_make: '', vehicle_color: '' }
      ]
    });
  };

  removeAlternateVehicle = (index) => {
    const alternateVehicles = [...this.state.alternateVehicles];
    alternateVehicles.splice(index, 1);
    this.setState({ alternateVehicles });
  };

  updateAlternateVehicle = (index, field, value) => {
    const alternateVehicles = [...this.state.alternateVehicles];
    alternateVehicles[index][field] = value;
    this.setState({ alternateVehicles });
  };

  openCarMakeModal = () => {
    this.setState({ showCarMakeModal: true, currentAlternateIndex: null });
  };

  openCarColorModal = () => {
    this.setState({ showCarColorModal: true, currentAlternateIndex: null });
  };

  openAlternateCarMakeModal = (index) => {
    this.setState({ showAlternateCarMakeModal: true, currentAlternateIndex: index });
  };

  openAlternateCarColorModal = (index) => {
    this.setState({ showAlternateCarColorModal: true, currentAlternateIndex: index });
  };

  closeModal = () => {
    this.setState({ 
      showCarMakeModal: false, 
      showCarColorModal: false,
      showAlternateCarMakeModal: false,
      showAlternateCarColorModal: false,
      currentAlternateIndex: null
    });
  };

  handleCarMakeChange = (value) => {
    const fields = { ...this.state.individualFields };
    fields['vehicle_make'] = value;
    this.setState({ individualFields: fields, showCarMakeModal: false });
  };

  handleCarColorChange = (value) => {
    const fields = { ...this.state.individualFields };
    fields['vehicle_color'] = value;
    this.setState({ individualFields: fields, showCarColorModal: false });
  };

  handleAlternateCarMakeChange = (value) => {
    if (this.state.currentAlternateIndex !== null) {
      this.updateAlternateVehicle(this.state.currentAlternateIndex, 'vehicle_make', value);
    }
    this.setState({ showAlternateCarMakeModal: false, currentAlternateIndex: null });
  };

  handleAlternateCarColorChange = (value) => {
    if (this.state.currentAlternateIndex !== null) {
      this.updateAlternateVehicle(this.state.currentAlternateIndex, 'vehicle_color', value);
    }
    this.setState({ showAlternateCarColorModal: false, currentAlternateIndex: null });
  };

  setIndividualErrors = (errors) => {
    this.setState({ individualErrors: errors });
  };

  handleAccountChange = (e) => {
    const fields = { ...this.state.accountFields };
    fields[e.target.name] = e.target.value;
    this.setState({ accountFields: fields });
  };

  handleAccountAreaCode = (areaCode) => {
    const fields = { ...this.state.accountFields };
    fields['areaCode'] = areaCode;
    this.setState({ accountFields: fields });
  };

  handleAccountDateChange = (value) => {
    this.setState({ accountValidity: value });
  };

  updateMember = (index, field, value) => {
    const members = [...this.state.members];
    members[index][field] = value;
    this.setState({ members });
  };

  updateMemberAreaCode = (index, areaCode) => {
    const members = [...this.state.members];
    members[index]['areaCode'] = areaCode;
    this.setState({ members });
  };

  addMember = () => {
    this.setState({
      members: [
        ...this.state.members,
        {
          first_name: '',
          last_name: '',
          areaCode: 1,
          phone1: '',
          email: '',
          vehicle_no: '',
          vehicle_make: '',
          vehicle_model: '',
          vehicle_color: '',
          alternate_vehicles: []
        }
      ]
    });
  };

  removeMember = (index) => {
    if (this.state.members.length > this.state.minMembers) {
      const members = [...this.state.members];
      members.splice(index, 1);
      this.setState({ members });
    }
  };

  openAccountCarMakeModal = (memberIndex) => {
    this.setState({ showAccountCarMakeModal: true, currentMemberIndex: memberIndex, currentAccountAlternateIndex: null });
  };

  openAccountCarColorModal = (memberIndex) => {
    this.setState({ showAccountCarColorModal: true, currentMemberIndex: memberIndex, currentAccountAlternateIndex: null });
  };

  openAccountAlternateCarMakeModal = (memberIndex, altIndex) => {
    this.setState({ showAccountCarMakeModal: true, currentMemberIndex: memberIndex, currentAccountAlternateIndex: altIndex });
  };

  openAccountAlternateCarColorModal = (memberIndex, altIndex) => {
    this.setState({ showAccountCarColorModal: true, currentMemberIndex: memberIndex, currentAccountAlternateIndex: altIndex });
  };

  closeAccountModal = () => {
    this.setState({ 
      showAccountCarMakeModal: false, 
      showAccountCarColorModal: false,
      currentMemberIndex: null,
      currentAccountAlternateIndex: null
    });
  };

  handleAccountCarMakeChange = (value) => {
    if (this.state.currentMemberIndex !== null) {
      if (this.state.currentAccountAlternateIndex !== null) {
        const members = [...this.state.members];
        if (!members[this.state.currentMemberIndex].alternate_vehicles) {
          members[this.state.currentMemberIndex].alternate_vehicles = [];
        }
        members[this.state.currentMemberIndex].alternate_vehicles[this.state.currentAccountAlternateIndex].vehicle_make = value;
        this.setState({ members });
      } else {
        this.updateMember(this.state.currentMemberIndex, 'vehicle_make', value);
      }
    }
    this.setState({ showAccountCarMakeModal: false, currentMemberIndex: null, currentAccountAlternateIndex: null });
  };

  handleAccountCarColorChange = (value) => {
    if (this.state.currentMemberIndex !== null) {
      if (this.state.currentAccountAlternateIndex !== null) {
        const members = [...this.state.members];
        if (!members[this.state.currentMemberIndex].alternate_vehicles) {
          members[this.state.currentMemberIndex].alternate_vehicles = [];
        }
        members[this.state.currentMemberIndex].alternate_vehicles[this.state.currentAccountAlternateIndex].vehicle_color = value;
        this.setState({ members });
      } else {
        this.updateMember(this.state.currentMemberIndex, 'vehicle_color', value);
      }
    }
    this.setState({ showAccountCarColorModal: false, currentMemberIndex: null, currentAccountAlternateIndex: null });
  };

  addAlternateVehicleToMember = (memberIndex) => {
    const limit = this.state.alternateVehicleLimit || 0;
    const members = [...this.state.members];
    if (!members[memberIndex].alternate_vehicles) {
      members[memberIndex].alternate_vehicles = [];
    }
    if (limit > 0 && members[memberIndex].alternate_vehicles.length >= limit) {
      return;
    }
    members[memberIndex].alternate_vehicles.push({ vehicle_no: '', vehicle_make: '', vehicle_color: '' });
    this.setState({ members });
  };

  removeAlternateVehicleFromMember = (memberIndex, altIndex) => {
    const members = [...this.state.members];
    if (members[memberIndex].alternate_vehicles) {
      members[memberIndex].alternate_vehicles.splice(altIndex, 1);
      this.setState({ members });
    }
  };

  updateAlternateVehicleInMember = (memberIndex, altIndex, field, value) => {
    const members = [...this.state.members];
    if (!members[memberIndex].alternate_vehicles) {
      members[memberIndex].alternate_vehicles = [];
    }
    members[memberIndex].alternate_vehicles[altIndex][field] = value;
    this.setState({ members });
  };

  setAccountErrors = (errors) => {
    this.setState({ accountErrors: errors });
  };

  manageBodyBackground = (isShow) => {
    if (isShow) {
      document.querySelector('#root').classList.add('dark');
    } else {
      document.querySelector('#root').classList.remove('dark');
    }
  };

  render() {
    const { 
      currentStep, 
      selectedPlan, 
      passList, 
      arenaName, 
      loading, 
      error, 
      loadingPricing,
      submittingForm,
      parkingId,
      monthlyAccountPrice,
      rentalFee,
      convFee,
      reservedSpot,
      isPayment,
      terms,
      no_of_spots
    } = this.state;

    if (currentStep === 2) {
      return (
        <CustomerInfo
          selectedPlan={selectedPlan}
          parkingId={parkingId}
          arenaName={arenaName}
          subscriptionType={selectedPlan?.subscriptionType || 'individual'}
          monthlyAccountPrice={monthlyAccountPrice}
          rentalFee={rentalFee}
          convFee={convFee}
          reservedSpot={reservedSpot}
          isPayment={isPayment}
          terms={terms}
          no_of_spots={no_of_spots}
          baseUrl={this.baseUrl}
          urlParams={this.urlParams}
          onBack={this.handleBackToPlans}
          loadingPricing={loadingPricing}
          submittingForm={submittingForm}
          calculateAccountPrice={this.calculateAccountPrice}
          lotType={this.state.lotType}
          isEnforcement={this.state.isEnforcement}
          isAutoApproval={this.state.isAutoApproval}
          booked={this.state.booked}
          env={this.env}
          onContinueToPayment={this.handleContinueToPayment}
          individualFields={this.state.individualFields}
          alternateVehicles={this.state.alternateVehicles}
          individualValidity={this.state.individualValidity}
          individualErrors={this.state.individualErrors}
          showCarMakeModal={this.state.showCarMakeModal}
          showCarColorModal={this.state.showCarColorModal}
          showAlternateCarMakeModal={this.state.showAlternateCarMakeModal}
          showAlternateCarColorModal={this.state.showAlternateCarColorModal}
          currentAlternateIndex={this.state.currentAlternateIndex}
          onIndividualChange={this.handleIndividualChange}
          onIndividualAreaCode={this.handleIndividualAreaCode}
          onIndividualDateChange={this.handleIndividualDateChange}
          onAddAlternateVehicle={this.addAlternateVehicle}
          onRemoveAlternateVehicle={this.removeAlternateVehicle}
          onUpdateAlternateVehicle={this.updateAlternateVehicle}
          onOpenCarMakeModal={this.openCarMakeModal}
          onOpenCarColorModal={this.openCarColorModal}
          onOpenAlternateCarMakeModal={this.openAlternateCarMakeModal}
          onOpenAlternateCarColorModal={this.openAlternateCarColorModal}
          onCloseModal={this.closeModal}
          onCarMakeChange={this.handleCarMakeChange}
          onCarColorChange={this.handleCarColorChange}
          onAlternateCarMakeChange={this.handleAlternateCarMakeChange}
          onAlternateCarColorChange={this.handleAlternateCarColorChange}
          onSetIndividualErrors={this.setIndividualErrors}
          accountFields={this.state.accountFields}
          members={this.state.members}
          accountValidity={this.state.accountValidity}
          accountErrors={this.state.accountErrors}
          minMembers={this.state.minMembers}
          showAccountCarMakeModal={this.state.showAccountCarMakeModal}
          showAccountCarColorModal={this.state.showAccountCarColorModal}
          currentMemberIndex={this.state.currentMemberIndex}
          currentAccountAlternateIndex={this.state.currentAccountAlternateIndex}
          onAccountChange={this.handleAccountChange}
          onAccountAreaCode={this.handleAccountAreaCode}
          onAccountDateChange={this.handleAccountDateChange}
          onUpdateMember={this.updateMember}
          onUpdateMemberAreaCode={this.updateMemberAreaCode}
          onAddMember={this.addMember}
          onRemoveMember={this.removeMember}
          onOpenAccountCarMakeModal={this.openAccountCarMakeModal}
          onOpenAccountCarColorModal={this.openAccountCarColorModal}
          onOpenAccountAlternateCarMakeModal={this.openAccountAlternateCarMakeModal}
          onOpenAccountAlternateCarColorModal={this.openAccountAlternateCarColorModal}
          onCloseAccountModal={this.closeAccountModal}
          onAccountCarMakeChange={this.handleAccountCarMakeChange}
          onAccountCarColorChange={this.handleAccountCarColorChange}
          onAddAlternateVehicleToMember={this.addAlternateVehicleToMember}
          onRemoveAlternateVehicleFromMember={this.removeAlternateVehicleFromMember}
          onUpdateAlternateVehicleInMember={this.updateAlternateVehicleInMember}
          onSetAccountErrors={this.setAccountErrors}
          allowAlternateVehicle={this.state.allowAlternateVehicle}
          alternateVehicleLimit={this.state.alternateVehicleLimit}
        />
      );
    }

    return (
      <div className="monthly-registration">
        <div className="monthly-registration__container">
          <ProgressSteps currentStep={1} />
          <ArenaHeader arenaName={arenaName} />

          {loading && (
            <div className="plan-grid__empty">
              <p>Loading plans...</p>
            </div>
          )}

          {!loading && error && (
            <div className="plan-grid__empty">
              <p>{error}</p>
            </div>
          )}

          {!loading && !error && (
            <PlanGrid
              plans={passList}
              selectedPlanId={selectedPlan ? selectedPlan.id : null}
              onSelectPlan={this.handlePlanSelect}
              parkingId={this.state.parkingId}
              is207CollegeSt={this.state.is207CollegeSt}
              is700BiscayneLot={this.state.is700BiscayneLot}
            />
          )}

          <div className="plan-actions">
            <button
              type="button"
              className={[
                'plan-actions__button',
                !selectedPlan || loadingPricing ? 'plan-actions__button--disabled' : ''
              ]
                .join(' ')
                .trim()}
              disabled={!selectedPlan || loadingPricing}
              onClick={this.handleContinue}
            >
              {loadingPricing ? 'Loading...' : 'Continue'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
